import { EventEmitter } from '@angular/core';

import { ListFilter, ListOrder, SelectOption } from '../../interfaces';
import { BaseComponent } from '../base/base.component';
/**
 * This component can handle the sorting and filtering logic.
 *
 * @export
 * @abstract
 * @class FilterableComponent
 * @extends {BaseComponent}
 */
export abstract class FilterableComponent extends BaseComponent {
  public filterChanged: EventEmitter<any> = new EventEmitter<any>();

  public orders: ListOrder[] = [];

  public filters: ListFilter[] = [];

  public searchText: string;

  public addFilter(filter: ListFilter, emitChange = true) {
    this.removeFilter(filter.key, false);
    this.filters.push(filter);

    if (emitChange) {
      this.filterChanged.emit();
    }
  }

  public removeFilter(key: string, emitChange = true) {
    this.filters = this.filters.filter((i) => i.key !== key);

    if (emitChange) {
      this.filterChanged.emit();
    }
  }

  public setFilter(filter: ListFilter, emitChange = true) {
    if (filter.value !== '' && filter.value !== null && filter.value !== undefined) {
      this.addFilter(filter, emitChange);
    } else {
      this.removeFilter(filter.key, emitChange);
    }
  }

  public setFilterFromSelect(option: SelectOption, emitChange = true) {
    if (option && option.key) {
      if (option.value) {
        this.addFilter({ key: option.key, value: option.value }, emitChange);
      } else {
        this.removeFilter(option.key, emitChange);
      }
    }
  }

  public resetFilters(filters: ListFilter[], emitChange = true) {
    this.filters = filters;

    if (emitChange) {
      this.filterChanged.emit();
    }
  }

  public clearFilters(emitChange = true) {
    this.resetFilters([], emitChange);
  }

  public addOrder(order: ListOrder, emitChange = true) {
    this.removeOrder(order.key, false);
    this.orders.push(order);

    if (emitChange) {
      this.filterChanged.emit();
    }
  }

  public removeOrder(key: string, emitChange = true): void {
    this.orders = this.orders.filter((i) => i.key !== key);

    if (emitChange) {
      this.filterChanged.emit();
    }
  }

  public setOrder(order: ListOrder, emitChange = true) {
    this.orders = order ? [order] : [];

    if (emitChange) {
      this.filterChanged.emit();
    }
  }

  public setOrderFromSelect(option: SelectOption, emitChange = true) {
    if (option.value) {
      this.setOrder({ key: option.key, reverse: option.value.toUpperCase() === 'DESC' }, emitChange);
    } else {
      this.clearOrders(emitChange);
    }
  }

  public resetOrders(orders: ListOrder[], emitChange = true) {
    this.orders = orders;

    if (emitChange) {
      this.filterChanged.emit();
    }
  }

  public clearOrders(emitChange = true) {
    this.resetOrders([], emitChange);
  }

  public setSearchText(value: string, emitChange = true) {
    this.searchText = value;

    if (emitChange) {
      this.filterChanged.emit();
    }
  }
}
